import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import TranslateTemplateSection from './TranslateTemplateSection';
import TranslateTemplateTextFieldGroup from './TranslateTemplateTextFieldGroup';
import TranslateTemplateFooterLinksSection from './TranslateTemplateFooterLinksSection';
import TranslateTemplateSocialNetworksSection from './TranslateTemplateSocialNetworksSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function TranslateTemplateFooterSection(props) {
  const {
    languages,
    onBackClick,
    onFieldChange,
    onSocialLinksFieldChange,
    onFooterLinkFieldChange,
    values
  } = props;
  const footerMessages = useMemo(() => values.map(langValues => langValues.footerMessage), [values]);
  const footerLinks = useMemo(() => values.map(langValues => langValues.footerLinks), [values]);
  const socialNetworks = useMemo(() => values.map(langValues => langValues.socialNetworksUrls), [values]);
  return /*#__PURE__*/_jsxs(TranslateTemplateSection, {
    onBackClick: onBackClick,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeContentUI.templateEditor.translateModal.sections.footer.header"
    }),
    children: [/*#__PURE__*/_jsx(TranslateTemplateTextFieldGroup, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.templateEditor.translateModal.sections.footer.fieldLabels.footerMessage"
      }),
      onChange: (language, value) => onFieldChange(language, 'footerMessage', value),
      values: footerMessages,
      languages: languages
    }), /*#__PURE__*/_jsx(TranslateTemplateFooterLinksSection, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.templateEditor.translateModal.sections.footer.fieldLabels.footerLinks"
      }),
      onChange: (language, index, uuid, value) => onFooterLinkFieldChange(language, 'footerLinks', index, uuid, value),
      values: footerLinks,
      languages: languages
    }), /*#__PURE__*/_jsx(TranslateTemplateSocialNetworksSection, {
      onChange: onSocialLinksFieldChange,
      values: socialNetworks,
      languages: languages
    })]
  });
}